import { useEffect } from "react"
import { useDeleteIllustrationMappings } from "../../../hooks/useIllustrationMappings"

const DeleteIllustrationMappingFacility = (props) => {
  const {
    onClose,
    illustrationMappingId,
    page,
    limit,
    sortBy,
    filters,
    mappingType,
  } = props
  const { endpoint, singular } = mappingType
  const {
    mutateAsync: deleteIllustrationMappingFacility,
    isPending: isDeletingIllustrationMappingFacility,
  } = useDeleteIllustrationMappings({ endpoint, page, limit, sortBy, filters })

  useEffect(() => {
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = "unset"
    }
  }, [])

  const handleDelete = async () => {
    await deleteIllustrationMappingFacility(illustrationMappingId)
    onClose()
  }

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-2xl w-full overflow-hidden">
        <div className="p-4 flex justify-between items-center">
          <p>
            {" "}
            <strong>Delete {singular}</strong>{" "}
          </p>
          <button
            className="text-gray-600 hover:text-gray-900 text-3xl ml-auto"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="max-h-96 overflow-y-auto p-4">
          <p>Do you want to delete this {singular}?</p>
          <div className="flex justify-end mt-4">
            <div className="flex justify-end mt-2">
              <button
                className="bg-gray-100 px-4 py-2 rounded-md mr-2 disabled:bg-gray-100 disabled:cursor-not-allowed"
                disabled={isDeletingIllustrationMappingFacility}
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                className="bg-red-700 hover:bg-red-800 text-white px-4 py-2 rounded-md mr-2 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:pointer-events-none"
                disabled={isDeletingIllustrationMappingFacility}
                onClick={handleDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteIllustrationMappingFacility
